import apiClient from './apiClient';

const staffService = {
  // List all staff for hotel
  getAll: () => apiClient.get('/auth/users/'),

  // Get single staff member
  getById: (id) => apiClient.get(`/auth/users/${id}/`),

  // Create new staff user
  create: (data) => apiClient.post('/auth/users/', data),

  // Update staff
  update: (id, data) => apiClient.patch(`/auth/users/${id}/`, data),

  // Deactivate staff (soft delete)
  remove: (id) => apiClient.del(`/auth/users/${id}/`),

  // Toggle active status
  setActive: (id, isActive) => apiClient.post(`/auth/users/${id}/set_active/`, { is_active: isActive }),

  // Get user permissions
  getPermissions: (id) => apiClient.get(`/auth/users/${id}/permissions/`),

  // Create permission
  createPermission: (data) => apiClient.post('/auth/permissions/', data),

  // Update permission
  updatePermission: (id, data) => apiClient.patch(`/auth/permissions/${id}/`, data),

  // Delete permission
  deletePermission: (id) => apiClient.del(`/auth/permissions/${id}/`),

  // Access-permission catalog: module/capability list + per-role default
  // matrices for the Staff modal "Access permissions" editor. 404s on
  // backends that predate custom roles — callers hide the section then.
  getAccessCatalog: () => apiClient.get('/auth/access-catalog/'),

  // Get current user with permissions
  getCurrentUser: () => apiClient.get('/v1/users/current'),

  // Change password
  changePassword: (data) => apiClient.put('/auth/change-password/', data),
};

export default staffService;
